import { render } from "./AListSubheader.vue?vue&type=template&id=580f2d5e&scoped=true"
import script from "./AListSubheader.vue?vue&type=script&lang=js"
export * from "./AListSubheader.vue?vue&type=script&lang=js"

import "./AListSubheader.vue?vue&type=style&index=0&id=580f2d5e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f2d5e"]])

export default __exports__